module.exports = __webpack_public_path__ + "static/media/gas-pump-slash.38968b3c.svg";